export interface OrgasmIconPositionsProps {
  mediaDuration: number;
  orgasms: number[];
  minGap: number;
}

export const orgasmIconPositions = ({
  mediaDuration,
  orgasms,
  minGap,
}: OrgasmIconPositionsProps) => {
  let result = orgasms.map((orgasm) => (orgasm / mediaDuration) * 100);

  result.forEach((orgasm, index) => {
    if (index === 0) return;

    const previousElement = result[index - 1];
    const gap = orgasm - previousElement;

    if (gap < minGap) {
      result[index] = previousElement + 10;
    }
  });

  return result.filter((orgasm) => orgasm < 100);
};
